import React from 'react';
import { useTranslation } from 'react-i18next';

import { IStrategy } from '../../types/model';
import { StrategyLabel } from './StrategyLabel';
import { DropdownMenu } from '../form';

const StrategySelect = ({
  className = '',
  strategies = [],
  strategy,
  setStrategy,
  color,
}: {
  className?: string;
  strategies: IStrategy[];
  strategy?: IStrategy;
  color: string;
  setStrategy: React.Dispatch<React.SetStateAction<IStrategy | undefined>>;
}) => {
  const { t } = useTranslation();

  return (
    <div className={`${className}`}>
      <DropdownMenu
        dropdownClassName={`
            flex
            items-center
            text-sm
          `}
        dropdownTooltipClassName={`
            bg-white
            border-solid
            border
            border-grey-10
            text-sm
            z-40
          `}
        buttonClassName={'px-2'}
        showArrow={strategies.length !== 0}
        dropdownArrowClassName="absolute right-3"
        dropdownTooltipXOffset={-10}
        dropdownTooltipYOffset={10}
        dropdownItemsData={strategies.map((s) => s)}
        dropdownItems={strategies.map((s) => (
          <StrategyLabel color={s.color} name={s.name} viewType={'simple'} />
        ))}
        handleClick={(_, strategy) => {
          setStrategy(strategy);
        }}
      >
        <StrategyLabel
          color={strategy?.color || color}
          name={strategy?.name || t('strategySelect.choose')}
          className="pr-8"
        />
      </DropdownMenu>
    </div>
  );
};

export default StrategySelect;
